import { defineSlotRecipe } from '@chakra-ui/react';

export const resultsOrderInfoSlotRecipe = defineSlotRecipe({
    slots: ['root'],
    base: {
        root: {
            justifyContent: 'space-between',
            bg: 'gray.100',
            h: {
                base: '40px',
                md: 'auto',
            },
            py: {
                base: 0,
                md: 3,
            },
            px: {
                base: 4,
                md: 3,
            },
            borderRadius: 'md',
            fontSize: 'sm',
            '& a': {
                ml: 1,
                color: 'secondary.600',
                fontWeight: 600,
            },
            '& button': {
                color: 'gray.600',
                my: -3,
                mx: { base: -4, md: -3 },
                px: 3,
            },
        },
    },
});
